import properCase from './proper-case';

const firstName = ref => {
	const name = ref.state ? ref.state.person.name : ref;
	return properCase((name+'').split(/\s+/)[0]);
}

export default firstName;